export const constant_store_info={
    title:"Your Order Please",
    description:"Your Order Please",
    keywords:"Your Order Please",
    author:"YOP",
    url:"",
    image:"",
    logo:"https://yopimages.s3.ap-south-1.amazonaws.com/store/2025/098774211generated-image.png"

}